import Lottie, { LottieComponentProps } from "lottie-react";
import animationData from "./animation.json";

export const IllustrationOpeningAnimation = (props: Omit<LottieComponentProps, "animationData">) => {
	return <Lottie animationData={animationData} {...props} />;
};
